import React from 'react';
import { Box, Typography } from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { useTranslation, Trans } from 'react-i18next';

import { useAiInspectorStyles } from './inspectorStyles';

const LiveBrandingStrip = () => {
  const { t: translate } = useTranslation();
  const classes = useAiInspectorStyles();

  return (
    <Box sx={classes.liveStrip} role="status">
      <WarningAmberOutlinedIcon sx={classes.liveStripIcon} />
      <Typography
        component="span"
        sx={{ fontSize: '11.5px', lineHeight: 1.45 }}
      >
        <Trans
          i18nKey="editorMode.aiLiveBrandingWarning"
          t={translate}
          components={[
            <Box key="strong" component="span" sx={classes.liveStripStrong} />,
          ]}
        />
      </Typography>
    </Box>
  );
};

export default LiveBrandingStrip;
